import { render, staticRenderFns } from "./category_list.vue?vue&type=template&id=c49d1e5c&scoped=true&"
import script from "./category_list.vue?vue&type=script&lang=js&"
export * from "./category_list.vue?vue&type=script&lang=js&"
import style0 from "./category_list.vue?vue&type=style&index=0&id=c49d1e5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c49d1e5c",
  null
  
)

export default component.exports